import type { TCountryCode } from "countries-list";

export const REVERSE_NAME_ORDER_COUNTRY_CODES: TCountryCode[] = ["KR", "JP"];
export const SHIPPING_PREFIX = "deliveryAddress";
export const BILLING_PREFIX = "billingAddress";
export const CountryWithPostalCodeAsAddressLookup = ["JP"];
